<template>
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="场站名称：">
            <el-select style="width: 230px;" v-model="formInline.stationId" filterable placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option
                v-for="item in stationOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="手机号：">
            <el-input v-model="formInline.phoneNumber" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="交易单号：">
            <el-input v-model="formInline.transactionId" placeholder="请输入交易单号"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
        </el-form-item>
    </el-form>
    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="充电站" show-overflow-tooltip>
            <template #default="scope">
            <div>
                <span>{{ scope.row.stationName }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="充电桩" show-overflow-tooltip>
            <template #default="scope">
            <div>
                <span>{{ scope.row.pileName }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="充电枪" show-overflow-tooltip>
            <template #default="scope">
            <div>
                <span>{{ scope.row.gunName }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column 
            label="交易单号" 
            width="150" 
            show-overflow-tooltip
            >
            <template #default="scope">
            <div>
                <span>{{ scope.row.transactionId }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="手机号" min-width="130">
            <template #default="scope">
            <div>
                <span>{{ scope.row.phoneNumber }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="车牌" min-width="100">
            <template #default="scope">
            <div>
                <span>{{ scope.row.license?scope.row.license:'--' }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="充电状态">
            <template #default="scope">
            <div>
                <span>{{ stateFilter(scope.row.chargeState) }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="起始SOC(%)" min-width="130">
            <template #default="scope">
            <div>
                <span>{{ scope.row.beginSoc }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="结束SOC(%)" min-width="130">
            <template #default="scope">
            <div>
                <span>{{ scope.row.endSoc }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="开始时间" min-width="180">
            <template #default="scope">
            <div>
                <span>{{ scope.row.beginTime }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="结束时间" min-width="180">
            <template #default="scope">
            <div>
                <span>{{ scope.row.endTime }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="消费金额">
            <template #default="scope">
            <div>
                <span>{{ scope.row.totalFee }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="充电服务费">
            <template #default="scope">
            <div>
                <span>{{ scope.row.serviceFee }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="充电电费">
            <template #default="scope">
            <div>
                <span>{{ scope.row.electricityFee }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="充电时长(分钟)">
            <template #default="scope">
            <div>
                <span>{{ scope.row.duration?scope.row.duration:'--' }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="充电量(kwh)	">
            <template #default="scope">
            <div>
                <span>{{ scope.row.chargeQuantity }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="业务状态" show-overflow-tooltip>
            <template #default="scope">
            <div>
                <span>{{ scope.row.chargeResultMsg?scope.row.chargeResultMsg:'--' }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
        <template #default="scope">
          <el-button type="success" size="small" @click="showInfo(scope.$index, scope.row)">
            详情
          </el-button>
        </template>
      </el-table-column>
      </el-table>
      <!-- 分页 -->
    <Pagination
        v-model:current-page="page"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

      <!-- 详情 -->
    <el-dialog v-model="isReadonly" title="订单详情" width="1000" :close-on-click-modal="false">
        <el-form :model="detailData" label-position="right" label-width="auto">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="场站名称：" prop="">
                        <div>{{detailData.stationName}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="充电桩：" prop="">
                        <div>
                        <span>{{detailData.pileName}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="充电枪：" prop="">
                        <div>{{detailData.gunName}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="交易单号：" prop="">
                        <div>
                        <span>{{detailData.transactionId}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="手机号：" prop="">
                        <div>{{detailData.phoneNumber}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="车牌：" prop="">
                        <div>
                        <span>{{detailData.license?detailData.license:'--'}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="充电状态：" prop="">
                        <div>{{ stateFilter(detailData.chargeState) }}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="起始SOC(%)：" prop="">
                        <div>
                        <span>{{detailData.beginSoc}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="结束SOC(%)：" prop="">
                        <div>{{detailData.endSoc}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="开始时间：" prop="">
                        <div>
                        <span>{{detailData.beginTime}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="结束时间：" prop="">
                        <div>{{detailData.endTime}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="消费金额：" prop="">
                        <div>
                        <span>{{detailData.totalFee}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="充电服务费：" prop="">
                        <div>{{detailData.serviceFee}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="充电电费：" prop="">
                        <div>
                        <span>{{detailData.electricityFee}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="充电时长(分钟)：" prop="">
                        <div>{{detailData.duration?detailData.duration:'--'}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="充电量(kwh)：" prop="">
                        <div>
                        <span>{{detailData.chargeQuantity}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="业务状态：" prop="">
                        <div>{{detailData.chargeResultMsg?detailData.chargeResultMsg:'--'}}</div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </el-dialog>

</template>
<script>
import { defineOptions } from 'vue';
defineOptions({
  name: 'ChargeOrderList'
})
</script>
<script setup>
import { ref, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { ElMessage } from 'element-plus';
import axios from '@/config/axios'; // 引入封装的axios实例

const store = useStore();

// 定义响应式数据
const stationOptions = ref(store.state.stationList || []);

// 监听 store 中的场站列表变化
watch(
    () => store.state.stationList,
    (newVal) => {
        if (newVal && newVal.length > 0) {
            stationOptions.value = newVal;
        }
    },
    { immediate: true }
);
const formInline = ref({
    transactionId: '',
    stationId: '',
    phoneNumber: ''
});
const tableData = ref([]);
const total = ref(0);
const page = ref(1);
const size = ref('small');
const pageSize = ref(10);
const isReadonly = ref(false);
const detailData = ref({});

const handleSizeChange = (val) => {
    pageSize.value = val;
    getList();
}
const handleCurrentChange = (val) => {
    page.value = val;
    getList();
}

const stateFilter = (val) => {
    switch (val) {
        case 1:
            return '正在充电';
        case 2:
            return '充电结束';
        default:
            return '未知';
    }
}

// 定义获取列表的方法
const getList = async () => {
    const param = {
        transactionId: formInline.value.transactionId,
        stationId: formInline.value.stationId || null,
        phoneNumber: formInline.value.phoneNumber,
        page: page.value,
        pageSize: pageSize.value
    };
    try {
        let that = this;
        const res = await axios.post(store.state.platformApi+'charge/record/list', param);
        if (res.code === 200) {
            tableData.value = res.data.records;
            total.value = res.data.total;
        }
    } catch (error) {
        console.error('请求错误:', error);
    }
};
const showInfo = (index, row) => {
    // console.log(index, row);
    let that = this;
    axios.post(that.$store.state.platformApi+'charge/record/view/'+row.id).then(res => {
        console.log(res);
        if(res.code === 200) {
            detailData.value = res.data;
            isReadonly.value = true;
        }
    })
};

// 组件挂载时调用获取列表方法
onMounted(() => {
    getList();
});
</script>
<style lang="scss">
.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 修改省略号颜色 */
// .el-table .cell {
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   color: #666; /* 自定义文字颜色 */
// }

/* 高亮显示省略号 */
// .el-table .cell:after {
//   content: "...";
//   color: #f56c6c;
// }
</style>